import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId", "actionMetadata", "getHeaderTitle", "eventAnchor", "recurAnnually"];
import PropTypes from 'prop-types';

// @ts-expect-error untyped module
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import Action from 'automation-ui-action-features/records/Action';
import ClassicAnchoredDelayActionMetadata from 'automation-ui-action-features/actions/classic-anchored-delay/records/ClassicAnchoredDelayActionMetadata';
import ClassicAnchoredDelayActionDetail from 'automation-ui-action-features/actions/classic-anchored-delay/ClassicAnchoredDelayActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
function ClassicAnchoredDelayActionCard(_ref) {
  let {
      actionId,
      actionMetadata,
      getHeaderTitle,
      eventAnchor,
      recurAnnually
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(ClassicAnchoredDelayActionDetail, {
      actionMetadata: actionMetadata,
      eventAnchor: eventAnchor,
      recurAnnually: recurAnnually
    })
  }));
}
ClassicAnchoredDelayActionCard.propTypes = {
  action: PropTypes.instanceOf(Action).isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  actionMetadata: PropTypes.instanceOf(ClassicAnchoredDelayActionMetadata).isRequired,
  flow: PropTypes.object.isRequired,
  flowObjectTypeId: ObjectTypeIdType.isRequired,
  onSelectAction: PropTypes.func,
  getHeaderTitle: PropTypes.func.isRequired
};
export default ClassicAnchoredDelayActionCard;